import { TextField } from "@mui/material";

function TextComponent({ label, value }) {
  return (
    <TextField
      data-testid="text-field"
      fullWidth
      label={label}
      value={value}
      InputProps={{ readOnly: true }}
      variant="outlined"
      size="small"
      inputProps={{ style: { textAlign: 'right' } }}
      sx={{ mb: 2, backgroundColor: "white" }}
    />
  );
}

export default TextComponent;